import { createApp } from 'vue'

import BaseAlert from '@/src/vueComponent/BaseAlert.vue'
import BackButton from '@/src/vueComponent/BackButton.vue'

$(document).on('turbo:load turbo:render', () => {
  const supplierShippingReportShow = document.querySelector('#supplier-shipping-report-show')
  if (supplierShippingReportShow && !supplierShippingReportShow.__vue_app__) {
    createApp({ components: { BaseAlert, BackButton } }).mount(supplierShippingReportShow)
  }
})
